import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';

export const StyledFilter = styled.div<{
    isToggleButton?: boolean;
    variant?: string;
}>(
    ifProp('isToggleButton', ({ theme }) => ({
        boxShadow: `0px 0px 0px 1px ${theme.colors.dark}`,
        padding: '0',
        height: theme.spaces[5],
        width: 'auto',
        minWidth: theme.spaces[6],
        margin: '0 1px 1px 0', // makes sure all lines are aligned when row is not fully filled with columns
        [`& ${StyledLabel}`]: {
            justifyContent: 'center',
        },
    }))
);

export const StyledLabel = styled.label<{ isToggleButton?: boolean }>(
    ({ theme }) => ({
        fontFamily: theme.fonts.body,
        display: 'flex',
        alignItems: 'center',
        height: theme.spaces[4],
        fontSize: theme.fontSizes.xs,
        fontWeight: theme.fontWeights.regular,
        justifyContent: 'flex-start',
        flex: '1',
        cursor: 'pointer',
        position: 'relative',
    }),
    ifProp('isToggleButton', () => ({
        paddingLeft: 0,
    }))
);

export const StyledItemCount = styled.span(({ theme }) => ({
    color: theme.colors.dark50,
    marginLeft: theme.spaces[1],
}));
